import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, TextField, MenuItem, CircularProgress } from "@mui/material";
import MDButton from "components/MDButton";
import { Checkbox, FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Grid";

export default function EditarCarreraModal({ open, onClose, carreraId, onCarreraActualizada }) {
  const [loading, setLoading] = useState(false);
  const [cargandoDatos, setCargandoDatos] = useState(true);
  const [institucion, setInstitucion] = useState("");
  const [nombre, setNombre] = useState("");
  const [duracion, setDuracion] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [matricula, setMatricula] = useState("");
  const [mensualidad, setMensualidad] = useState("");
  const [tipo, setTipo]= useState("");
  const [incluyeTexto, setIncluyeTexto] = useState(false);
  const [estado, setEstado] = useState(1);

  const token = sessionStorage.getItem("access_token");
    const formatDate = (datetime) => {
        if (!datetime) return "";
            return datetime.split(" ")[0]; // toma solo la parte YYYY-MM-DD
        };
  // Traer info de la carrera cuando se abre el modal o cambia el id
  useEffect(() => {
    if (!carreraId) return;

    setCargandoDatos(true);
    fetch(`${process.env.REACT_APP_API_URL}/carreras/${carreraId}/info`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then(res => res.json())
      .then(data => {
        const carrera = data.data || data; // depende de tu backend
        setNombre(carrera.nombre || "");
        setDuracion(carrera.duracion || "");
        setFechaInicio(formatDate(carrera.fecha_inicio));
        setTipo(carrera.tipo || "");
        setIncluyeTexto(carrera.incluye_texto ?? false);
        setEstado(carrera.estado ?? 1);
        setCargandoDatos(false);
      })
      .catch(err => {
        console.error(err);
        setCargandoDatos(false);
      });
  }, [carreraId, token]);

  const handleSubmit = async () => {
    setLoading(true);

    const payload = {
      nombre: nombre || null,
      duracion: duracion || null,
      fecha_inicio: fechaInicio || null,
      tipo: tipo || null,
      incluye_texto: incluyeTexto,
      estado,
    };
    
    try {
      const action = carreraId ? "update" : "create";
      const url =
        action === "create"
          ? `${process.env.REACT_APP_API_URL}/carreras`
          : `${process.env.REACT_APP_API_URL}/carreras/${carreraId}`;

      const res = await fetch(url, {
        method: action === "create" ? "POST" : "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Error al guardar carrera");

      onCarreraActualizada();
      onClose();
    } catch (err) {
      console.error("Error al editar carrera:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 }, // padding responsive
          width: { xs: '90%', sm: 400, md: 500 }, // 🔥 clave
          maxHeight: '90vh', // evita que se salga de pantalla
          overflowY: 'auto', // scroll interno
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h6" mb={2}>
          Editar Carrera
        </Typography>

        {cargandoDatos ? (
          <CircularProgress />
        ) : (
          <>

            <TextField fullWidth label="Nombre" value={nombre} onChange={(e) => setNombre(e.target.value)} sx={{ mb: 2 }} />
            <Grid container spacing={2} sx={{ mb: 2 }}>
              {/* TIPO */}
              <Grid item xs={6}>
                <TextField
                  select
                  fullWidth
                  label="Tipo"
                  value={tipo}
                  onChange={(e) => {
                    setTipo(e.target.value);
                    setDuracion(""); // reset duración cuando cambia tipo
                  }}
                  SelectProps={{ native: true }}
                >
                  <option value=""></option>
                  <option value="anual">Anual</option>
                  <option value="semestral">Semestral</option>
                </TextField>
              </Grid>

              {/* DURACIÓN DINÁMICA */}
              <Grid item xs={6}>
                <TextField
                  select
                  fullWidth
                  label="Duración"
                  value={duracion}
                  onChange={(e) => setDuracion(e.target.value)}
                  SelectProps={{ native: true }}
                  disabled={!tipo}
                >
                  <option value=""></option>

                  {tipo === "anual" && (
                    <>
                      <option value="2">2 años</option>
                      <option value="3">3 años</option>
                    </>
                  )}

                  {tipo === "semestral" && (
                    <>
                      <option value="4">4 semestres</option>
                      <option value="6">6 semestres</option>
                    </>
                  )}
                </TextField>
              </Grid>
            </Grid>
            <TextField fullWidth type="date" label="Fecha Inicio" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} sx={{ mb: 2 }}/>
            <MDButton variant="contained" color="info" fullWidth onClick={handleSubmit} disabled={loading}>
              {loading ? <CircularProgress size={24} /> : "Guardar cambios"}
            </MDButton>
          </>
        )}
      </Box>
    </Modal>
  );
}
